import style from "./style.module.scss";

function QuestionBox({ data, marginTop, bg }) {
    return <div className={style.QuestionBox + " row"} style={{ ...(bg ? { backgroundColor: bg } : { backgroundImage: `url("Images/infopages/questionbox/back.jpg")` }), ...(marginTop ? { marginTop } : {})
}}>
    <div className={style.content}>
        <div className={style.title}>
            {data.title}
        </div>
        <div className={style.text}>
            {(() => {
                const lines = [];
                for (let i = 0; i < data.text.length; i++) {
                    lines.push(data.text[i]);
                    if (i !== (data.text.length - 1)) lines.push(<br />);
                }
                return lines;
            })()}
        </div>

        <div className={style.button}>
            {data.button}
        </div>
    </div>
    </div >
}

export default QuestionBox;